import { render, staticRenderFns } from "./rules.mpx?vue&type=template&id=032b9ede&scoped=true&component=true&componentId=rules8abb0012"
import script from "./rules.mpx?vue&type=script&lang=js&component=true&componentId=rules8abb0012"
export * from "./rules.mpx?vue&type=script&lang=js&component=true&componentId=rules8abb0012"
import style0 from "./rules.mpx?vue&type=style&index=0&id=032b9ede&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m8abb0012%22%7D&component=true&componentId=rules8abb0012"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b9ede",
  null
  
)

export default component.exports